<template>
	<router-link :to="{ name: 'account.profile' }">Account</router-link>
</template>

<script>
export default {};
</script>
